import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  background: #272727;
`;

export const FooterContent = styled.div`
  max-width: 600px;
  margin: 40px auto;
  padding: 0px 20px 0px 20px;

  p {
    padding-top: 20px;
    font-size: 15px;
    line-height: 22px;
    text-align: center;

    color: #ffffff;
  }

  span {
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;

    text-transform: uppercase;

    color: #ffffff;
  }
`;

export const FooterItems = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  margin: 20px auto;

  a {
    color: #ffffff;
    font-size: 10px;

    text-decoration-line: underline;
    text-transform: uppercase;

    & + a {
      margin-left: 50px;
    }
  }
`;
